// PGCET MCA Mock 9 — Mathematics (questions 1–30)
const pgcetmcaMathematics = [
  {
    id: 1,
    question: "The price of a commodity is first increased by 20% and then decreased by 25%. The net effect on the price is",
    options: ["A. 5% decrease", "B. 10% decrease", "C. 5% increase", "D. No change"],
    answer: "B"
  },
  {
    id: 2,
    question: "The population of a town is 12,500 and it grows at 8% per annum, compounded annually. The population after 2 years will be",
    options: ["A. 14,580", "B. 14,500", "C. 14,620", "D. 14,400"],
    answer: "A"
  },
  {
    id: 3,
    question: "A shopkeeper marks his goods 40% above the cost price and then allows a discount of 15% on the marked price. His profit percentage is",
    options: ["A. 25%", "B. 21%", "C. 19%", "D. 17%"],
    answer: "C"
  },
  {
    id: 4,
    question: "By selling an article for Rs. 1,140 a trader loses 5%. At what price should he sell it to gain 10%?",
    options: ["A. Rs. 1,254", "B. Rs. 1,300", "C. Rs. 1,350", "D. Rs. 1,320"],
    answer: "D"
  },
  {
    id: 5,
    question: "A can complete a piece of work in 12 days and B in 18 days. They work together for 4 days, after which A leaves. In how many more days will B finish the remaining work?",
    options: ["A. 8", "B. 6", "C. 10", "D. 9"],
    answer: "A"
  },
  {
    id: 6,
    question: "Pipe A can fill a tank in 20 minutes and pipe B in 30 minutes, while pipe C can empty the full tank in 15 minutes. If all three pipes are opened together on an empty tank, it will be filled in",
    options: ["A. 45 minutes", "B. 60 minutes", "C. 50 minutes", "D. 75 minutes"],
    answer: "B"
  },
  {
    id: 7,
    question: "A train 240 m long crosses a platform 360 m long in 30 seconds. The speed of the train in km/h is",
    options: ["A. 64.8", "B. 60", "C. 72", "D. 80"],
    answer: "C"
  },
  {
    id: 8,
    question: "A car travels from town P to town Q at 60 km/h and returns from Q to P along the same road at 40 km/h. Its average speed for the whole journey is",
    options: ["A. 50 km/h", "B. 45 km/h", "C. 52 km/h", "D. 48 km/h"],
    answer: "D"
  },
  {
    id: 9,
    question: "A boat covers 30 km downstream in 2 hours and 24 km upstream in 3 hours. The speed of the boat in still water is",
    options: ["A. 11.5 km/h", "B. 12 km/h", "C. 10.5 km/h", "D. 3.5 km/h"],
    answer: "A"
  },
  {
    id: 10,
    question: "A sum of money at simple interest amounts to Rs. 7,200 in 3 years and to Rs. 8,400 in 5 years. The rate of interest per annum is",
    options: ["A. 10%", "B. 11 1/9 %", "C. 12%", "D. 12 1/2 %"],
    answer: "B"
  },
  {
    id: 11,
    question: "The difference between the compound interest (compounded annually) and the simple interest on Rs. 15,000 for 2 years at 8% per annum is",
    options: ["A. Rs. 120", "B. Rs. 84", "C. Rs. 96", "D. Rs. 108"],
    answer: "C"
  },
  {
    id: 12,
    question: "Rs. 6,500 is divided among A, B and C in the ratio 1/2 : 1/3 : 1/4. The share of B is",
    options: ["A. Rs. 1,500", "B. Rs. 2,500", "C. Rs. 2,600", "D. Rs. 2,000"],
    answer: "D"
  },
  {
    id: 13,
    question: "In what ratio must rice costing Rs. 42 per kg be mixed with rice costing Rs. 54 per kg so that the mixture is worth Rs. 46 per kg?",
    options: ["A. 1 : 2", "B. 2 : 1", "C. 3 : 2", "D. 2 : 3"],
    answer: "B"
  },
  {
    id: 14,
    question: "A 60-litre mixture contains milk and water in the ratio 7 : 3. How many litres of water must be added to make the ratio of milk to water 1 : 1?",
    options: ["A. 18", "B. 20", "C. 24", "D. 30"],
    answer: "C"
  },
  {
    id: 15,
    question: "The HCF of two numbers is 16 and their LCM is 480. If one of the numbers is 96, the other number is",
    options: ["A. 64", "B. 80", "C. 72", "D. 112"],
    answer: "B"
  },
  {
    id: 16,
    question: "The least number which, when divided by 12, 15, 20 and 54, leaves a remainder of 8 in each case is",
    options: ["A. 548", "B. 540", "C. 1088", "D. 552"],
    answer: "A"
  },
  {
    id: 17,
    question: "The remainder when 2¹⁰⁰ is divided by 7 is",
    options: ["A. 1", "B. 4", "C. 2", "D. 3"],
    answer: "C"
  },
  {
    id: 18,
    question: "The number of trailing zeros at the end of 125! (125 factorial) is",
    options: ["A. 25", "B. 30", "C. 32", "D. 31"],
    answer: "D"
  },
  {
    id: 19,
    question: "If log₁₀ x − log₁₀ √x = 2 logₓ 10, then x equals",
    options: ["A. 100 or 1/100", "B. 10 or 1/10", "C. 100 only", "D. 1000"],
    answer: "A"
  },
  {
    id: 20,
    question: "The value of log₂ 3 × log₃ 4 × log₄ 5 × … × log₁₅ 16 is",
    options: ["A. 2", "B. 4", "C. 8", "D. 16"],
    answer: "B"
  },
  {
    id: 21,
    question: "For positive a, b, c (with abc ≠ 1 and ab, bc, ca ≠ 1), the value of 1/log_ab(abc) + 1/log_bc(abc) + 1/log_ca(abc) is",
    options: ["A. 1", "B. 3", "C. 2", "D. 0"],
    answer: "C"
  },
  {
    id: 22,
    question: "The principal value of sin⁻¹(sin(5π/6)) is",
    options: ["A. 5π/6", "B. −π/6", "C. π/6", "D. π/3"],
    answer: "C"
  },
  {
    id: 23,
    question: "The value of 2 tan⁻¹(1/3) + tan⁻¹(1/7) is",
    options: ["A. π/3", "B. π/2", "C. π/6", "D. π/4"],
    answer: "D"
  },
  {
    id: 24,
    question: "The value of cos(2 sin⁻¹(1/3)) is",
    options: ["A. 7/9", "B. 2/3", "C. 1/9", "D. 8/9"],
    answer: "A"
  },
  {
    id: 25,
    question: "The area of the region bounded by the parabola y = x² and the line y = 4 is",
    options: ["A. 16/3 sq. units", "B. 32/3 sq. units", "C. 8 sq. units", "D. 64/3 sq. units"],
    answer: "B"
  },
  {
    id: 26,
    question: "The total area enclosed between the curve y = sin x and the x-axis from x = 0 to x = 2π is",
    options: ["A. 0", "B. 2", "C. 4", "D. 2π"],
    answer: "C"
  },
  {
    id: 27,
    question: "The minimum value of f(x) = x + 9/x for x > 0 is",
    options: ["A. 3", "B. 9", "C. 10", "D. 6"],
    answer: "D"
  },
  {
    id: 28,
    question: "An open box with a square base is made from a 12 cm × 12 cm square sheet of tin by cutting equal squares from the four corners and folding up the sides. For the volume of the box to be maximum, the side of each square cut off should be",
    options: ["A. 2 cm", "B. 3 cm", "C. 1.5 cm", "D. 4 cm"],
    answer: "A"
  },
  {
    id: 29,
    question: "A simple undirected graph has 10 vertices and every vertex has degree 4. The number of edges in the graph is",
    options: ["A. 40", "B. 10", "C. 24", "D. 20"],
    answer: "D"
  },
  {
    id: 30,
    question: "A connected planar graph has 8 vertices and 12 edges. By Euler's formula, the number of faces (regions, including the unbounded one) in any planar drawing of it is",
    options: ["A. 4", "B. 5", "C. 8", "D. 6"],
    answer: "D"
  }
];

export default pgcetmcaMathematics;
